export enum SourceType {
  CONTACT = "CONTACT",
  PRODUCT = "PRODUCT",
}

export enum ImportationStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export interface IImportationInput {
  sourceType: SourceType;
  midiaId: number;
  userId: number;
  profileId: number | null;
  status: ImportationStatus;
  success: number;
  created: number;
  updated: number;
  fail: number;
  total: number;
  message: string | null;
  mediaName: string;
  integrationDate: Date;
}

export default interface IImportation extends IImportationInput {
  id: string;
  rowDate: string;
}
